import { ChainId, Token, WNATIVE } from '@pancakeswap/sdk'
import { USDT_ETH } from './common'

export const ethTokens = {
  wEth: WNATIVE[ChainId.ETH],
  usdt: USDT_ETH,
}